import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FuseSharedModule } from '@fuse/shared.module';
import { FuseWidgetModule } from '@fuse/components';
import { WgWhistleblowerComponent } from './wg-whistleblower.component';


@NgModule({
  declarations: [WgWhistleblowerComponent],
  imports: [
    CommonModule,
    FuseSharedModule,
    FuseWidgetModule,
  ],
  exports: [WgWhistleblowerComponent]
})
export class WgWhistleblowerModule { }
